<template>
    <v-container fluid >
      <v-skeleton-loader
        class="mx-auto"
        min-width="300"
        type="text"
      ></v-skeleton-loader>
    </v-container>
</template>

<script>
export default {
  name: 'SourceSkeleton'
}
</script>
